import { Injectable } from '@angular/core';

declare const gtag: any;

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  public trackEvent(eventName: string, params: Object = {}) {
    gtag('event', eventName, params);
  }
}
